import { Check, Copy } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./mcp-info-section.i18n";

type McpInfoSectionProps = {
  mcpUrl: string;
};

export function McpInfoSection({ mcpUrl }: McpInfoSectionProps) {
  const t = useT(T);
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(mcpUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t.title}</CardTitle>
        <CardDescription>{t.description}</CardDescription>
      </CardHeader>
      <CardContent>
        <div>
          <h4 className="text-sm font-medium mb-2">{t.endpoint}</h4>
          <div className="flex items-center gap-2">
            <code className="flex-1 p-2 bg-muted rounded-md text-sm">{mcpUrl}</code>
            <Button
              variant="outline"
              size="icon"
              tooltip={t.copy}
              onClick={handleCopy}
              className="shrink-0"
            >
              {copied ? <Check className="h-4 w-4 text-success" /> : <Copy className="h-4 w-4" />}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
